var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"color":"accent","indeterminate":"","active":!!_vm.isActive,"height":"4"}})}
var staticRenderFns = []

export { render, staticRenderFns }